import { SvgIcon, SvgIconProps } from '@mui/material'
import React from 'react'

export const ArrowDownward:React.FC<SvgIconProps> = (props) => (
  <SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path d="M12 5V19M12 19L19 12M12 19L5 12" stroke="currentColor" fill="transparent" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  </SvgIcon>
)
